import { render, staticRenderFns } from "./CascaderMenu.vue?vue&type=template&id=3fd48d4c&scoped=true"
import script from "./CascaderMenu.vue?vue&type=script&lang=js"
export * from "./CascaderMenu.vue?vue&type=script&lang=js"
import style0 from "./CascaderMenu.vue?vue&type=style&index=0&id=3fd48d4c&prod&scoped=true&lang=scss"
import style1 from "./CascaderMenu.vue?vue&type=style&index=1&id=3fd48d4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd48d4c",
  null
  
)

export default component.exports